@if (section && item && editMode) {
<section
  class="pia-entryContentBlock pia-entryContentBlock-section{{ section.id }}"
>
  <header autoscroll="true" class="pia-entryContentBlock-header">
    <div>
      @if ( sidStatusService.sidStatusIcon[
      sidStatusService.itemStatus[section.id + '.' + item.id] ]) {
      <span>
        @if ( sidStatusService.sidStatusIcon[
        sidStatusService.itemStatus[section.id + '.' + item.id] ] ==
        'faPenToSquare' ) {
        <fa-icon [icon]="faPenToSquare"></fa-icon>
        } @if ( sidStatusService.sidStatusIcon[
        sidStatusService.itemStatus[section.id + '.' + item.id] ] ==
        'faPenToSquare,pia-fa-valid' ) {
        <fa-icon [icon]="faPenToSquare"></fa-icon>
        } @if ( sidStatusService.sidStatusIcon[
        sidStatusService.itemStatus[section.id + '.' + item.id] ] == 'faGear' )
        {
        <fa-icon [icon]="faGear"></fa-icon>
        } @if ( sidStatusService.sidStatusIcon[
        sidStatusService.itemStatus[section.id + '.' + item.id] ] ==
        'faGear,pia-fa-valid' ) {
        <fa-icon [icon]="faGear"></fa-icon>
        } @if ( sidStatusService.sidStatusIcon[
        sidStatusService.itemStatus[section.id + '.' + item.id] ] ==
        'faSquareCheck' ) {
        <fa-icon [icon]="faSquareCheck"></fa-icon>
        }
      </span>
      } @else { @if ( sidStatusService.specialIcon[section.id + '.' + item.id]
      == 'faChartLine' ) {
      <fa-icon [icon]="faChartLine"></fa-icon>
      } @if ( sidStatusService.specialIcon[section.id + '.' + item.id] ==
      'faCalendarCheck' ) {
      <fa-icon [icon]="faCalendarCheck"></fa-icon>
      } }
      <div class="pia-entryContentBlock-header-progress">
        @if (sidStatusService.itemStatus[section.id + '.' + item.id] <= 4) {
        <div>
          {{ "pia.header.edition" | translate }}
        </div>
        } @if ( sidStatusService.itemStatus[section.id + '.' + item.id] > 4 &&
        sidStatusService.itemStatus[section.id + '.' + item.id] <= 7 ) {
        <div>
          {{ "pia.header.evaluation" | translate }}
        </div>
        }
      </div>
    </div>
    <div class="pia-entryContentBlock-header-title">
      @if (section.title) {
      <h1>{{ section.title | translate }}</h1>
      } @if (section.short_help) {
      <h3>{{ section.short_help | translate }}</h3>
      } @if (item.title) {
      <h2>{{ item.title | translate }}</h2>
      } @if (item.short_help) {
      <h4>{{ item.short_help | translate }}</h4>
      }
    </div>
    @if (pia.is_example === 1 || (pia.status != 0 && pia.status != 1)) {
    <a routerLink="/preview/{{ pia.id }}" class="btn pia-previewBlock">
      <span class="pia-icons pia-icon-preview"></span>
      @if (section.id === 4 && item.id === 2) {
      <div [innerHTML]="'pia.header.display_action_plan' | translate"></div>
      } @else {
      <div>{{ "pia.header.preview" | translate }}</div>
      }
    </a>
    }
  </header>
  <!-- Back to edition -->
  @if ( globalEvaluationService.status === 4 && pia.is_example !== 1 &&
  (editMode.includes('author') || editMode === 'local') ) {
  <div class="pia-status-info evaluationsStatus">
    <div>
      <strong>{{ "pia.sections.status.evaluation.title" | translate }}</strong>
      <p>
        <span
          [innerHTML]="'pia.sections.status.evaluation.content' | translate"
        ></span>
        <a
          href="javascript:;"
          (click)="cancelAskForEvaluation()"
          [innerHTML]="'pia.sections.status.evaluation.cancel' | translate"
        ></a>
      </p>
    </div>
  </div>
  }
  <!-- Back to evaluation -->
  @if ( globalEvaluationService.status === 7 && pia.is_example !== 1 &&
  !(section.id == 4 && item.id == 3) && (editMode.includes('evaluator') ||
  editMode === 'local') ) {
  <div class="pia-status-info">
    <div>
      <strong>{{ "pia.sections.status.validation.title" | translate }}</strong>
      <p>
        <span
          [innerHTML]="'pia.sections.status.validation.content' | translate"
        ></span>
        <a
          href="javascript:;"
          (click)="cancelValidateEvaluation()"
          [innerHTML]="'pia.sections.status.validation.cancel' | translate"
        ></a>
      </p>
    </div>
  </div>
  } @if (!loading) { @if (item.is_measure) { @if (
  globalEvaluationService.answerEditionEnabled && (editMode.includes('author')
  || editMode === 'local') ) {
  <button
    (click)="onAddNewMeasure()"
    class="btn btn-white btn-addMeasure"
    type="button"
  >
    <span class="pia-icons pia-icon-add"></span>
    {{ "measures.add" | translate }}
  </button>
  } @for (measure of measures; track measure) {
  <app-measures
    [editMode]="editMode"
    [measure]="measure"
    [pia]="pia"
    [section]="section"
    [item]="item"
    (deleted)="onDeletedMeasure($event)"
  >
  </app-measures>
  } } @else { @for (question of questions; track question) {
  <app-questions
    [editMode]="editMode"
    [question]="question"
    [pia]="pia"
    [section]="section"
    [item]="item"
  >
  </app-questions>
  } } } @else {
  <div class="pia-sectionBlock-body" style="position:relative; height: 150px;">
    <app-loading-overlay
      [visibility]="true"
      [childMode]="true"
    ></app-loading-overlay>
  </div>
  } @if (item.evaluation_mode === 'item') {
  <app-evaluations
    [editMode]="editMode"
    [pia]="pia"
    [section]="section"
    [item]="item"
  >
  </app-evaluations>
  } @if (section.id == 3 && item.id == 5) {
  <div [pia]="pia" class="app-overview-risks"></div>
  } @if (section.id == 4 && item.id == 4) {
  <app-validate-pia [editMode]="editMode" [pia]="pia"></app-validate-pia>
  } @if (section.id == 4 && item.id == 5) {
  <app-refuse-pia [editMode]="editMode" [pia]="pia"></app-refuse-pia>
  } @if (section.id == 4 && item.id == 1) {
  <div [pia]="pia" class="app-risks-cartography"></div>
  } @if (section.id == 4 && item.id == 2) {
  <app-action-plan [pia]="pia" [data]="data"></app-action-plan>
  } @if (section.id == 4 && item.id == 3) {
  <app-dpo-people-opinions
    [editMode]="editMode"
    [pia]="pia"
  ></app-dpo-people-opinions>
  }
  <footer class="pia-entryContentBlock-footer">
    @if (globalEvaluationService.status > 0) {
    <div>
      @if ( (globalEvaluationService.status === 1 ||
      globalEvaluationService.status === 2 || globalEvaluationService.status ===
      3) && (editMode.includes('author') || editMode === 'local') ) {
      <button
        class="btn btn-green"
        (click)="prepareForEvaluation()"
        [ngClass]="{
          'btn-active':
            globalEvaluationService.status === 2 ||
            globalEvaluationService.status === 3
        }"
        [disabled]="globalEvaluationService.status === 1"
      >
        {{ "pia.footer.ask_evaluation" | translate }}
      </button>
      } @if ( (globalEvaluationService.status === 5 ||
      globalEvaluationService.status === 6) && (editMode.includes('evaluator')
      || editMode === 'local') ) {
      <button
        class="btn btn-green"
        (click)="validateEvaluation()"
        [ngClass]="{ 'btn-active': globalEvaluationService.status === 6 }"
        [disabled]="globalEvaluationService.status === 5"
      >
        {{ "pia.footer.validate_evaluation" | translate }}
      </button>
      } @if ( globalEvaluationService.status === 7 && !(section.id == 4 &&
      item.id == 3) ) {
      <button class="btn btn-pending-validation" disabled>
        <fa-icon [icon]="faSquareCheck"></fa-icon>
        {{ "pia.footer.subsection_validated" | translate }}
      </button>
      }
      <p class="pia-entryContentBlock-footer-requiredFields">
        {{ "pia.footer.mandatory_fields" | translate }}
      </p>
      @if ( pia.is_example !== 1 && globalEvaluationService.status === 4 &&
      (editMode.includes('author') || editMode === 'local') ) {
      <button class="btn pia-cancelBtn" (click)="cancelAskForEvaluation()">
        {{ "pia.sections.status.evaluation.cancel_button" | translate }}
      </button>
      } @if ( pia.is_example !== 1 && globalEvaluationService.status === 7 &&
      !(section.id == 4 && item.id == 3) && (editMode.includes('evaluator') ||
      editMode === 'local') ) {
      <button class="btn pia-cancelBtn" (click)="cancelValidateEvaluation()">
        {{ "pia.sections.status.validation.cancel_button" | translate }}
      </button>
      }
    </div>
    }
    <div class="pia-entryContentBlock-footer-nav">
      <a
        [ngClass]="{ mask: paginationService.hasPreviousLink === false }"
        class="pia-previousLink"
        routerLink="/pia/{{ pia.id }}/section/{{
          paginationService.previousLink[0]
        }}/item/{{ paginationService.previousLink[1] }}"
      >
        <fa-icon [icon]="faAngleDoubleLeft"></fa-icon>
        {{ paginationService.previousLink[2] | translate }} </a
      ><a
        [ngClass]="{ mask: paginationService.hasNextLink === false }"
        class="pia-nextLink"
        routerLink="/pia/{{ pia.id }}/section/{{
          paginationService.nextLink[0]
        }}/item/{{ paginationService.nextLink[1] }}"
      >
        {{ paginationService.nextLink[2] | translate }}
        <fa-icon [icon]="faAngleDoubleRight"></fa-icon>
      </a>
    </div>
  </footer>
</section>
}
